import { JSON_CONTENT_TYPE, TOKEN_NAME } from '../../constant/constants';
import { ErrorListDto } from '../../dto/error/ErrorLIstDto';
import { IApiParams } from '../../interface/IApiParams';
import { getApi } from '../getApi';

export const apiAddError = async (dto: ErrorListDto) => {
  const params: IApiParams = {
    url: '/error/addInfo.php',
    headers: {
      'Content-Type': JSON_CONTENT_TYPE,
      Token: localStorage.getItem(TOKEN_NAME),
    },
  };
  return getApi(params, 'POST', dto);
};
